export default __webpack_public_path__ + "static/media/vinhoTaça.65b60ef7.jpg";